import api from './api';
export default {

    post: data => api.post('/api/report/objects', data),
}